module.exports = __webpack_public_path__ + "weathericons-regular-webfont.8cac70ebda3f23ce4721.woff";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/css/weather/font/weathericons-regular-webfont.woff
// module id = ../../../../../theme/css/weather/font/weathericons-regular-webfont.woff
// module chunks = styles